"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var tooltip_1 = require("../tooltip");
var config_context_1 = require("../_util/config-context");
var constants_1 = require("./constants");
var SIZE_MAP = {
    s: 10,
    l: 32,
    default: 16,
};
var SvgWrapper = styled_components_1.default.span(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  svg {\n    width: ", "px;\n    height: ", "px;\n  }\n"], ["\n  svg {\n    width: ", "px;\n    height: ", "px;\n  }\n"])), function (props) { return props.size; }, function (props) { return props.size; });
var SvgWrapperWithColor = styled_components_1.default.span(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  svg {\n    width: ", "px;\n    height: ", "px;\n    polygon, rect, path, circle, ellipse, line, polyline {\n      fill: ", ";\n    }\n  }\n"], ["\n  svg {\n    width: ", "px;\n    height: ", "px;\n    polygon, rect, path, circle, ellipse, line, polyline {\n      fill: ", ";\n    }\n  }\n"])), function (props) { return props.size; }, function (props) { return props.size; }, function (props) { return props.color; });
exports.Icon = (0, react_1.forwardRef)(function (props, ref) {
    var _a;
    var classPrefix = (0, config_context_1.useConfig)().classPrefix;
    var _b = props.type, type = _b === void 0 ? '' : _b, size = props.size, color = props.color, gradientColors = props.gradientColors, className = props.className, tooltip = props.tooltip, link = props.link, htmlProps = (0, tslib_1.__rest)(props, ["type", "size", "color", "gradientColors", "className", "tooltip", "link"]);
    var isFlagIcon = type.includes('flag-');
    var isWeightIcon = constants_1.WEIGHT_ICONS.includes(type);
    var isPngIcon = constants_1.PNG_ICONS.includes(type);
    var iconClassName = (0, classnames_1.default)(className, classPrefix + "-icon-" + type, (_a = {},
        _a[classPrefix + "-icon"] = !isFlagIcon,
        _a[classPrefix + "-flag-icon"] = isFlagIcon,
        _a[classPrefix + "-icon-weight"] = isWeightIcon,
        _a['size-s'] = size === 's',
        _a['size-l'] = size === 'l',
        _a));
    var svgSize = typeof size === 'number' ? size : (SIZE_MAP[size] || 16);
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var Parent = link ? 'a' : 'i';
    var label = type.replace('-blue', '').replace('-hover', '');
    var renderSvgIcon = function () {
        var icon = constants_1.ICON_MAP[type];
        if (['loading', 'loading-white'].includes(type)) { // loading icon 比较特殊，是带渐变色的
            var uniqKey = '';
            var colors = gradientColors;
            if (type === 'loading-white') {
                colors = ['rgba(255, 255, 255, 1)', 'rgba(255, 255, 255, 0.5)', 'rgba(255, 255, 255, 0)'];
            }
            if (colors && colors.length > 0) {
                uniqKey = "" + Math.random();
            }
            icon = constants_1.ICON_MAP.loading(uniqKey, colors);
        }
        return color ? (react_1.default.createElement(SvgWrapperWithColor, { color: color, size: svgSize, dangerouslySetInnerHTML: { __html: icon } })) : (react_1.default.createElement(SvgWrapper, { size: svgSize, dangerouslySetInnerHTML: { __html: icon } }));
    };
    var renderPngIcon = function () {
        var style = typeof size === 'number' ? { width: size + "px", height: size + "px" } : {};
        return react_1.default.createElement("span", { style: style });
    };
    var icon = (react_1.default.createElement(Parent, (0, tslib_1.__assign)({ ref: ref, className: iconClassName, role: "img", "aria-label": label }, htmlProps, { style: (0, tslib_1.__assign)((0, tslib_1.__assign)({}, (typeof size === 'number' ? { width: size + "px", height: size + "px" } : {})), (htmlProps.style || {})) }), isPngIcon ? renderPngIcon() : renderSvgIcon()));
    if (tooltip) {
        return react_1.default.createElement(tooltip_1.Tooltip, { title: tooltip }, icon);
    }
    return icon;
});
exports.Icon.displayName = 'Icon';
var templateObject_1, templateObject_2;
